export default {
  PRIMARY: 'PRIMARY',
};
